import Route from "@ember/routing/route";
import type { DatabaseDetailsRouteModel } from "glesys-controlpanel/databases/details/route";

export default class DatabasesDetailsOverviewRoute extends Route {
  model(): DatabaseDetailsRouteModel {
    return this.modelFor("databases.details") as DatabaseDetailsRouteModel;
  }
}
